export default "__VITE_ASSET__9313d6f1__"